import React from 'react';
import PropTypes from 'prop-types';

const ToggleSwitch = ({ cn, isOn, onClick, areaClassName, buttonClassName }) => (
  <div className={cn(areaClassName, { on: isOn })} onClick={onClick}>
    <div className={cn(buttonClassName, { on: isOn })} />
  </div>
);

ToggleSwitch.displayName = 'ToggleSwitch';

ToggleSwitch.propTypes = {
  areaClassName: PropTypes.string,
  buttonClassName: PropTypes.string,
  cn: PropTypes.func.isRequired,
  isOn: PropTypes.bool,
  onClick: PropTypes.func,
};

ToggleSwitch.defaultProps = {
  areaClassName: 'toggle-area',
  buttonClassName: 'toggle-button',
  isOn: false,
  onClick: () => {},
};

module.exports = ToggleSwitch;
